import React from "react";
import Slider from "react-slick";
import { Box, useTheme } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ImageCarousel = ({ images, altTexts }) => {
  const theme = useTheme();

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: true,
    arrows: true,
    centerMode: false,
    centerPadding: "0px",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          centerPadding: "0px",
        },
      },
    ],
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100%",
        "& .slick-slider": {
          borderRadius: "12px",
          overflow: "hidden",
          margin: "0",
          padding: "0",
        },
        "& .slick-list": { margin: "0", padding: "0" },
        "& .slick-track": { margin: "0", padding: "0" },
        "& .slick-slide": { padding: "0" },
        "& .slick-arrow": {
          zIndex: 2,
          "&:before": { fontSize: "30px", color: "#818cf8" },
        },
        "& .slick-prev": { left: "10px" },
        "& .slick-next": { right: "10px" },
        "& .slick-dots": {
          bottom: "20px",
          "& li button": {
            width: "16px",
            height: "16px",
            borderRadius: "50%",
            border: `2px solid ${theme.palette.primary.main}`,
            backgroundColor: "rgba(255,255,255,0.15)",
            "&:before": { display: "none" },
          },
          "& li.slick-active button": {
            backgroundColor: theme.palette.primary.main,
            border: "2px solid rgba(255,255,255,0.8)",
          },
        },
      }}
    >
      <Slider {...settings}>
        {images.map((image, index) => (
          <Box key={index}>
            <Box
              component="img"
              src={image}
              alt={altTexts[index]}
              sx={{ width: "100%", height: "auto", objectFit: "cover", display: "block" }}
            />
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default ImageCarousel;
